<div class="flex w-full justify-center items-center">
  <div class="text-center">
    <h2 class="text-2xl text-green-700 py-4">Message sent successfully!</h2>
    <h3 class="text-lg pb-2">
      Thank you for reaching out. We will contact you as soon as possible.
    </h3>
  </div>
</div>
